import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useSubdistrict(regency_id?: string) {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const params: { [key: string]: number | string | undefined } = {};
  if (regency_id) params.regency_id = regency_id;

  const refetch = (regency_id?: string) => {
    setLoading(true)

    api.get("/subdistricts/", {
      params: { regency_id: regency_id }
    }).then((res: SuccessFetch<{
      payload: {
        regency_id?: string
        subdistrict_id: string
        subdistrict_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.subdistrict_name,
          value: item.subdistrict_id,
          regency_id: item.regency_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    api.get("/subdistricts/", { params }).then((res: SuccessFetch<{
      payload: {
        regency_id?: string
        subdistrict_id: string
        subdistrict_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.subdistrict_name,
          value: item.subdistrict_id,
          regency_id: item.regency_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}